import { showErrorAxios } from "infra/helpers/alerta";
import http from "infra/http";
import { useMutation, useQueryClient } from "react-query";
import { FracaoCreateOrUpdateRequest } from "../typings";

const getRoute = (id: string) => `/v1/fracao/${id}/`;
function useEditFracao() {
  const queryClient = useQueryClient();

  return useMutation(
    "edit/v1/fracao/:id",
    ({ id, data }: { id: string; data: FracaoCreateOrUpdateRequest }) =>
      http.put(getRoute(id), data),
    {
      retry: false,
      onSuccess: (_, { id }) => {
        queryClient.invalidateQueries([getRoute(id), "/v1/fracao"]);
      },
      onError: (e) => {
        showErrorAxios(e)
      }
    }
  );
}

export default useEditFracao;
